import {ValueDefinition} from '@/model/types';

export enum LegacyFeeType {
  RedemptionFees = 'DV-85#0',
  NoLoad = 'DV-85#1',
  ModerateRedemptionFees = 'DV-85#2',
  AdvisorChargeback3Years = 'DV-85#3',
  AdvisorChargeback5Years = 'DV-85#4',
}

export const DV_85 = {
  id: 'DV-85',
  description: {
    fr: 'Type de frais La Capitale',
    en: 'La Capitale fee type',
  },
  type: 'FeeType',
  values: [
    {
      id: '0',
      value: {
        fr: 'Frais au rachat',
        en: 'Redemption fees',
      },
      properties: {
        id_beneva: '0',
        DtDb: '2007-12-03',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Sans frais de souscription',
        en: 'No-load fees',
      },
      properties: {
        id_beneva: '1',
        DtDb: '2007-12-03',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '2',
      value: {
        fr: 'Frais au rachat modéré',
        en: 'Moderate Redemption fees',
      },
      properties: {
        id_beneva: '4',
        DtDb: '2007-12-03',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '3',
      value: {
        fr: 'Récupération de commission – conseiller 3 ans',
        en: 'Advisor Chargeback 3 years',
      },
      properties: {
        id_beneva: '6',
        DtDb: '2018-04-23',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '4',
      value: {
        fr: 'Récupération de commission – conseiller 5 ans',
        en: 'Advisor Chargeback 5 years',
      },
      properties: {
        id_beneva: '5',
        DtDb: '2018-04-23',
        DtFi: '2199-12-31',
      },
    },
  ],
} as const satisfies ValueDefinition;
